import { TemplateRef } from '@angular/core';

export type TooltipSize = 'sm' | 'md';
export type TooltipPosition = 'top' | 'bottom';
export type TooltipHorizontalPosition = 'start' | 'center' | 'end';

export class TooltipConfig {
  content: string|TemplateRef<any>;
  position: TooltipPosition;
  horizontalPosition: TooltipHorizontalPosition;
  size: TooltipSize;
}
